import React, {useEffect, useRef} from "react";
import useYetizProfileEncoder from "../../yetizProfileEncoder/useYetizProfileEncoder";
import yetiz from "yetiz";


const YetizSnowProfile = ({profile={}, yetizProperties={}, graphRef, width="1000px", height="1414px", ...props}) => {
    const profileSvgRef = useRef(null);
    const yetizProfileEncoder = useYetizProfileEncoder();

    useEffect(
        () => {
            if(yetizProfileEncoder.isReady){
                const properties = {
                    right_icon: '/img/models4_small.png',
                    right_icon_caption: "YetiWeb",
                    left_icon: profile.station?.workgroup?.logo?.path,
                    left_icon_caption: profile.station?.workgroup?.name,
                    ...yetizProperties,
                }
                const jsonProfile = yetizProfileEncoder.encodeJSON(profile);
                yetiz.parse(jsonProfile, "json", (err, station) => {
                    if (err) {
                        console.error(err);
                    } else {

                        const graph = new yetiz.SnowProfile(station, profileSvgRef.current, properties);
                        if (graphRef) {
                            graphRef.current = graph;
                        }
                    }
                })
            }
        }, [yetizProfileEncoder.isReady, yetizProfileEncoder.encodeJSON, profile, yetizProperties, width, height]
    )
    const {style, ...restProps} = props;

    return <svg ref={profileSvgRef} style={{ width: width, height: height, ...style}} {...restProps} />
}

export {
    YetizSnowProfileContainer,
    YetizSnowProfileZoomWrapper,
    YetizSnowProfileTools,
    YetizSnowProfileZoom,
    useYetizSnowProfileZoom,
    useYetizSnowProfileProperties,
    useYetizSnowProfileMenu
} from "./Components";

export default YetizSnowProfile;
